export class LoanDetails {
  constructor() {
    this.interestRate = 0;
    this.apr = 0; // where to pull this from?
    this.purchasePrice = 0;
    this.downPaymentAmount = 0;
    this.loanAmount = 0;
  }
}
